import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { connect } from 'react-redux'
import AuthService from '../../services/auth/auth.service.js'
import { logoutUser } from '../../actions/auth'
import { AppBar, Toolbar } from '@material-ui/core'
import { NavDrawer } from "./NavDrawer"

class NavBarFittbd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawerOpened: false
    }
  }

  toggleDrawer = booleanValue => () => {
    this.setState({
      drawerOpened: booleanValue
    })
  }

  onReloadLogoutPages = () => {
    this.props.onLoadLogoutPages()
  }

  onReloadPages = (route) => {
    this.props.onLoadPages(route)
  }

  handleLogout() {
    AuthService.logout()
    this.onReloadLogoutPages()
  }

  handlePage(route) {
    this.onReloadPages(route)
  }

  render() {
    var get_uri = window.location.pathname
    var sep_uri = get_uri.split("/")
    var get_uri2 = sep_uri[2]

    return (
      <div class="subNav d-none d-sm-block">
        <h3>Our Clinic</h3>
        <ul>
          <li><a href="/our-clinic-/fitt-bd">Specialty Clinic: FITT-BD</a>
            <ul>
              <li><a href="https://fitt-bd.org/introduction/introduction1">Introduction to FITT-BD</a></li>{/*/our-clinic-/fitt-bd-brochure*/}
              <li><a href="/our-clinic-/fitt-bd-brochure">View our brochure</a></li>{/**/}
              <li><a href="/our-clinic-/faq">FAQs</a></li>
            </ul>
          </li>
          <li><a href="/our-clinic-/consultations">Consultations & Ongoing Care</a></li>
        </ul>
        <hr />
        {get_uri2 != 'consultations' &&<p>
        “I felt like people knew my case. I knew the FITT-BD team would sit down each week and talk about the patients and see how they were doing. It wouldn’t just be notes in a system, it would be a conversation, it would be them taking time to understand how each patient was doing. The FITT-BD program was very much a system of continuity of care. There were always notes being passed, there was the portal, there was a centralization of data that was really helpful. So just the connectedness of FITT-BD is a unique model.” - <b>Former FITT-BD Patient</b>
        </p>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    uid: state.authReducer.uid,
    role: state.authReducer.role,
    p_st: state.authReducer.p_st,
    b_step: state.authReducer.b_step,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoadLogoutPages() {
    dispatch(logoutUser())
  },
  onLoadPages(route) {
    //dispatch(updateLocation(route))
    dispatch({
      type: 'UPDATE_LOCATION',
      payload: {route: route},
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBarFittbd)
